import { LocalTime } from '@js-joda/core'
import { Api, GlobalSettingsApi, HttpClient } from '../../../api'
import { Context, runIfDefined } from '../../../common'
import { GlobalSettings, GlobalSettingsService, UpdateGlobalSettingsOpts } from './globalSettings'

function mapDtoToGlobalSettings(dto: Api.GlobalSettings): GlobalSettings {
  return {
    id: '',
    createdAt: new Date(0),
    anonymousRoleId: dto.anonymousRoleId,
    cardActivationDelay: dto.cardActivationDelay,
    reportsCloseTime: runIfDefined(dto.reportsCloseTime, time => LocalTime.parse(time)) ?? undefined,
  }
}

export class RemoteGlobalSettingsService implements GlobalSettingsService {
  private api: GlobalSettingsApi

  constructor(httpClient: HttpClient) {
    this.api = new GlobalSettingsApi(httpClient, undefined, '')
  }

  async load(ctx: Context): Promise<GlobalSettings | undefined> {
    const result = await this.api.globalSettingsGetObject(ctx)
    return mapDtoToGlobalSettings(result.body.object)
  }

  async update(ctx: Context, settings: UpdateGlobalSettingsOpts): Promise<void> {
    await this.api.globalSettingsUpdate(ctx, settings)
  }
}
